import { useColorScheme } from '@mui/joy';
import { Moon, Sun } from '@phosphor-icons/react';

import { Button } from 'core/components/Button';
import { ModeType } from 'theme/enums';

const ICON_SIZE = 24;
// The theme caps icon-button SVGs at 18px; the header icons are drawn at 24px.
const BUTTON_SX = { '& svg': { width: ICON_SIZE, height: ICON_SIZE } };

export const ModeToggle = () => {
  const { mode, setMode } = useColorScheme();

  const toggleMode = () => {
    const newMode = mode === ModeType.LIGHT ? ModeType.DARK : ModeType.LIGHT;

    setMode(newMode);
  };

  return (
    <Button
      onClick={toggleMode}
      icon={mode === ModeType.LIGHT ? <Moon size={ICON_SIZE} /> : <Sun size={ICON_SIZE} />}
      sx={BUTTON_SX}
    />
  );
};
